// src/services/analytics.service.js

import axios from 'axios';
import authHeader from './auth-header';

// Gọi TRỰC TIẾP tới report.dhbtools.com (không qua API server proxy)
const REPORT_URL = process.env.REACT_APP_REPORT_SERVER;

class AnalyticsService {

    /**
     * Tab 1: Overview — KPI + timeline + top tools
     */
    getOverview(from, to, tool, serverName) {
        const params = new URLSearchParams();
        if (from) params.append('from', from);
        if (to) params.append('to', to);
        if (tool) params.append('tool', tool);
        if (serverName) params.append('serverName', serverName);
        return axios.get(`${REPORT_URL}/analytics/overview?${params}`, { headers: authHeader() });
    }

    /**
     * Tab 2: User Behavior — login analytics, search by username/app/version
     */
    getUserBehavior(from, to, { tool, app, version, search, page = 1, limit = 50 } = {}) {
        const params = new URLSearchParams();
        if (from) params.append('from', from);
        if (to) params.append('to', to);
        if (tool) params.append('tool', tool);
        if (app) params.append('app', app);
        if (version) params.append('version', version);
        if (search) params.append('search', search);
        params.append('page', page);
        params.append('limit', limit);
        return axios.get(`${REPORT_URL}/analytics/users?${params}`, { headers: authHeader() });
    }

    /**
     * Tab 3: Endpoints — API endpoint statistics with search/sort
     */
    getEndpoints(from, to, { tool, search, sort = 'calls', page = 1, limit = 20 } = {}) {
        const params = new URLSearchParams();
        if (from) params.append('from', from);
        if (to) params.append('to', to);
        if (tool) params.append('tool', tool);
        if (search) params.append('search', search);
        params.append('sort', sort);
        params.append('page', page);
        params.append('limit', limit);
        return axios.get(`${REPORT_URL}/analytics/endpoints?${params}`, { headers: authHeader() });
    }

    /**
     * Tab 4: Errors — Error tracking with status filter
     */
    getErrors(from, to, { tool, status, search, page = 1, limit = 50 } = {}) {
        const params = new URLSearchParams();
        if (from) params.append('from', from);
        if (to) params.append('to', to);
        if (tool) params.append('tool', tool);
        if (status) params.append('status', status);
        if (search) params.append('search', search);
        params.append('page', page);
        params.append('limit', limit);
        return axios.get(`${REPORT_URL}/analytics/errors?${params}`, { headers: authHeader() });
    }

    /**
     * Tab 5: Live Monitor — realtime request feed
     */
    getLiveMonitor(minutes = 5, limit = 50) {
        return axios.get(`${REPORT_URL}/analytics/live?minutes=${minutes}&limit=${limit}`, { headers: authHeader() });
    }
}

export default new AnalyticsService();
